/* unplugin-vue-components disabled */import { render } from "./logistics_list.vue?vue&type=template&id=798e8e2f&scoped=true"
import script from "./logistics_list.vue?vue&type=script&lang=js"
export * from "./logistics_list.vue?vue&type=script&lang=js"

import "./logistics_list.vue?vue&type=style&index=0&id=798e8e2f&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798e8e2f"]])

export default __exports__